export const Svg_107 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M32.813 10.938V0h4.374v10.938h-4.374Zm-13.636 3.864-8.094-8.167L14.146 3.5l8.166 8.167-3.135 3.135Zm-8.24 52.281c-.62 0-1.139-.21-1.558-.629-.42-.419-.629-.938-.629-1.558V41.27l6.125-17.84a4.32 4.32 0 0 1 1.568-2.176c.753-.559 1.616-.838 2.588-.838h8.313v-5.47H38.5a19.962 19.962 0 0 0-2.734 4.595 18.145 18.145 0 0 0-1.35 5.25H18.814l-4.375 12.833H37.99a21.39 21.39 0 0 0 2.114 2.37A17.547 17.547 0 0 0 42.584 42H13.124v14.583h43.75V44.698c.778-.194 1.53-.417 2.254-.667.725-.25 1.432-.562 2.121-.937v21.802c0 .62-.21 1.14-.629 1.558-.42.42-.939.63-1.559.63h-1.53c-.62 0-1.14-.21-1.56-.63-.419-.419-.628-.938-.628-1.558v-3.938h-40.76v3.938c0 .62-.21 1.14-.63 1.558-.419.42-.938.63-1.558.63h-1.459ZM18.23 51.48h8.75c.632 0 1.155-.21 1.568-.632.413-.422.62-.945.62-1.568 0-.623-.21-1.142-.63-1.555-.418-.413-.938-.62-1.558-.62h-8.75v4.375Zm33.542 0v-4.375h-8.75c-.632 0-1.155.211-1.568.633-.413.421-.62.944-.62 1.567 0 .624.21 1.142.63 1.555.419.414.938.62 1.558.62h8.75Zm-.875-18.666 10.281-10.355-2.042-2.041-8.24 8.312-4.301-4.375-2.042 2.115 6.344 6.343Zm1.969-20.344c3.913 0 7.25 1.379 10.008 4.137 2.758 2.759 4.137 6.095 4.137 10.009 0 3.913-1.379 7.25-4.137 10.008-2.759 2.758-6.095 4.137-10.008 4.137-3.914 0-7.25-1.379-10.009-4.137-2.758-2.759-4.137-6.095-4.137-10.008 0-3.914 1.379-7.25 4.137-10.009 2.759-2.758 6.095-4.137 10.009-4.137Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={22.223}
        x2={55.883}
        y1={10.063}
        y2={57.374}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h70v70H0z" />
      </clipPath>
    </defs>
  </svg>
)